import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [firstName, setFirstName] = useState('');
  // const [lastName, setLastName] = useState('');
  const [name, setName] = useState("");
  // const [errorMsg, setErrorMsg] = useState("");
  // const [showPassword, setShowPassword] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errors, setErrors] = useState({});
  // const [passwordRequirements, setPasswordRequirements] = useState({
  //   length: false,
  //   uppercase: false,
  //   lowercase: false,
  //   number: false,
  //   special: false,
  // });
  const { register, loading } = useAuth();
  const navigate = useNavigate();

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }
    return newErrors;
  };

  // useEffect(() => {
  //   const requirements = {
  //     length: password.length >= 8,
  //     uppercase: /[A-Z]/.test(password),
  //     lowercase: /[a-z]/.test(password),
  //     number: /\d/.test(password),
  //     special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  //   };
  //   setPasswordRequirements(requirements);
  // }, [password]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return; // ❌ stop submission
    }

    setErrors({}); // clear old errors

    try {
      const result = await register(name, email, password);
      if (result.success) {
        setSuccessMsg(result.message);
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    } catch (err) {
      console.error("Registration error:", err.message);

      // map backend error messages to correct field
      if (err.message.toLowerCase().includes("password")) {
        setErrors({ password: err.message });
      } else if (err.message.toLowerCase().includes("email")) {
        setErrors({ email: err.message });
      } else if (err.message.toLowerCase().includes("name")) {
        setErrors({ name: err.message });
      } else if (err.message.toLowerCase().includes("user already exists")) {
        setErrors({ email: err.message });
      } else {
        // fallback general error (could be shown in Alert if you want)
        setErrors({ general: err.message });
      }
    }
  };

  // const handleClickShowPassword = () => setShowPassword((show) => !show);
  // const handleMouseDownPassword = (e) => e.preventDefault();

  return (
    <Container maxWidth="xs">
      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        sx={{
          mt: 20,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 500, mb: 4 }}>
          CREATE ACCOUNT
        </Typography>

        {/* {errorMsg && (
          <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
            {errorMsg}
          </Alert>
        )} */}

        {successMsg && (
          <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
            {successMsg}
          </Alert>
        )}
        {errors.general && (
          <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
            {errors.general}
          </Alert>
        )}

        <Typography
          variant="subtitle2"
          sx={{ mb: 1, letterSpacing: 1.2, fontSize: "12px" }}
        >
          {/* FIRST NAME */}
          NAME
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          required
          size="small"
          name="name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (errors.name) {
              setErrors((prev) => ({ ...prev, name: "" })); // clear only name error
            }
          }}
          error={!!errors.name}
          helperText={errors.name}
          FormHelperTextProps={{ sx: { marginLeft: 0 } }}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": { borderRadius: 0 },
          }}
        />

        {/* <Typography
          variant="subtitle2"
          sx={{ mb: 1, letterSpacing: 1.2, fontSize: "12px" }}
        >
          LAST NAME
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          required
          size="small"
          name="lastName"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": { borderRadius: 0 },
          }}
        /> */}

        <Typography
          variant="subtitle2"
          sx={{ mb: 1, letterSpacing: 1.2, fontSize: "12px" }}
        >
          EMAIL
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          required
          type="email"
          size="small"
          name="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (errors.email) {
              setErrors((prev) => ({ ...prev, email: "" })); // clear only email error
            }
          }}
          error={!!errors.email}
          helperText={errors.email}
          FormHelperTextProps={{ sx: { marginLeft: 0 } }}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": { borderRadius: 0 },
          }}
        />

        <Typography
          variant="subtitle2"
          sx={{ mb: 1, letterSpacing: 1.2, fontSize: "12px" }}
        >
          PASSWORD
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          required
          type="password"
          size="small"
          name="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (errors.password) {
              setErrors((prev) => ({ ...prev, password: "" })); // clear only password error
            }
          }}
          error={!!errors.password}
          helperText={errors.password}
          FormHelperTextProps={{ sx: { marginLeft: 0 } }}
          sx={{
            mb: 4,
            "& .MuiOutlinedInput-root": { borderRadius: 0 },
          }}
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          disableRipple
          disableElevation
          sx={{
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: 0,
            py: 1.5,
            mb: 1,
            minHeight: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:hover": {
              backgroundColor: "#000",
            },
            "&:focus": {
              backgroundColor: "#000",
            },
            "&:active": {
              backgroundColor: "#000",
            },
            "&.Mui-disabled": {
              backgroundColor: "#000",
              color: "#fff",
              opacity: 1,
            },
          }}
        >
          {loading ? (
            <CircularProgress
              size={18}
              sx={{ color: "white", position: "absolute" }}
            />
          ) : null}

          <span style={{ visibility: loading ? "hidden" : "visible" }}>
            CREATE
          </span>
        </Button>

        <Box sx={{ mt: 4 }}>
          <Typography
            variant="body2"
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/login")}
          >
            Already have an account? Sign in
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Register;
